import React from 'react';

import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes';

import { GlobalQuestionsListMacro } from '../src/QuestionList/GlobalQuestionsListMacro';
import { FlagsProvider } from '../src/FlagsProvider';

type GlobalQuestionsListMacroHandlerProps = {
	macroDefaultProps: ExtensionHandlerProps;
	macroParams: any;
};

export const GlobalQuestionsListMacroHandler: React.FC<GlobalQuestionsListMacroHandlerProps> = ({
	macroParams,
}) => {
	const limit = macroParams?.limit?.value ? parseInt(macroParams.limit.value, 10) : 10;
	const filter = macroParams?.filter?.value?.toLowerCase() || 'popular';
	const space = macroParams?.space?.value;
	const includeTopics = macroParams?.['include-topics']?.value || 'all';
	const topicsString = macroParams?.topic?.value || '';

	const topics = topicsString
		? topicsString
				.split(',')
				.map((topic: string) => topic.trim())
				.filter(Boolean)
		: [];

	return (
		<FlagsProvider>
			<GlobalQuestionsListMacro
				limit={limit}
				filter={filter}
				space={space}
				includeTopics={includeTopics}
				topics={topics}
			/>
		</FlagsProvider>
	);
};
